import { BaseComponent } from '../base-component.js';

export class AgPanelFooter extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-panel-footer"><slot></slot></div>`;
  }
}

customElements.define('ag-panel-footer', AgPanelFooter);
